<template>
  <div class="l-modal" >
    <div class="loading-modal w-full">
      <div class="loader  bg-white">
        <div class="custom-border bg-white w-full">
          <div class=" bg-white w-7/12 mx-auto rounded my-3 flex flex-col gap-y-2.5">
            <div class=" border-army flex flex-col gap-y-1.5">
              <label class="capitalize font-semibold text-sm">
                Enter Your car plate number
              </label>
              <input type="text" placeholder="Eg IKJ 355 VA" v-model="PlateNumber" class="text-black bg-custom p-2.5 border-0 rounded focus-within:outline-none"/>
            </div>
            <button class="rounded border-0 bg-army text-sm font-bold p-2.5 w-full text-white" @click="autoCheck">
              Submit
            </button>
          </div>
        </div>
      </div>
<!--KSF97GX-->
    </div>
  </div>
</template>

<script>

import axios from "axios";
import baseURL from "@/main";

export default {
  components: {},
  data() {
    return {
      next: false,
      PlateNumber: "",
    };
  },
  methods: {
    async autoCheck() {
      this.$store.commit('startLoading')
      await axios({url: `${baseURL}/vehicle/details/${this.PlateNumber}`, method: 'GET'})
          .then(res => {
            console.log(res);
            this.$store.commit('setAutoCheckData', res.data.data)
            this.$emit('show')
            this.$store.commit('endLoading')

          })
          .catch(err => {
            this.$store.dispatch('handleError', err)
            this.$store.commit('endLoading')
          })
      this.$store.commit('endLoading')

    }
  }

}
</script>

<style scoped>
.loader {
  position: relative;
  top: 50%;
  left: 50%;
  transform: translate(-50%, 50%);
  max-width: 400px;
  background-color: #f7f7f7;
}
.custom-border {
  border: 9px solid ;
  border-image-source: url(../../../../assets/images/border.png);
  border-image-slice: 61 58 51 48;
  border-image-width: 30px 30px 30px 30px;
  border-image-repeat: stretch stretch;
}

</style>